import React, { Component } from "react";
import {
  loading,
  NavbarAdmin,
  GET,
  t
} from "../../components/CustomComponent.js";

const AVATAR_BG = ["bg-primary", "bg-success", "bg-warning", "bg-secondary", "bg-info", "bg-dark"];

const WO_STATUS_COLORS = {
  open: "#0d6efd",
  assigned: "#6f42c1",
  in_progress: "#fd7e14",
  completed: "#198754",
};

export default class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loaded: false,
      kpi: {
        open_wo: 0,
        new_today: 0,
        in_progress: 0,
        techs_active: 0,
        pending_wr: 0,
        completed_today: 0,
      },
      wo_by_status: [],
      recent_work_requisitions: [],
      technicians: [],
      recent_activities: [],
    };
  }

  async componentDidMount() {
    await this.getData();
  }

  getData = async () => {
    loading(true);
    const result = await GET("admin/dashboard");
    if (result?.status && result.data) {
      const d = result.data;
      this.setState({
        loaded: true,
        kpi: d.kpi || this.state.kpi,
        wo_by_status: d.wo_by_status || [],
        recent_work_requisitions: d.recent_work_requisitions || [],
        technicians: d.technicians || [],
        recent_activities: d.recent_activities || [],
      });
    } else {
      this.setState({ loaded: true });
    }
    loading(false);
  };

  timeAgo = (iso) => {
    if (!iso) return "";
    const diffMs = Date.now() - new Date(iso).getTime();
    if (Number.isNaN(diffMs) || diffMs < 0) return "";
    const min = Math.floor(diffMs / 60000);
    if (min < 1) return t("just_now");
    if (min < 60) return `${min} ${t("minutes_ago")}`;
    const hr = Math.floor(min / 60);
    if (hr < 24) return `${hr} ${t("hours_ago")}`;
    return `${Math.floor(hr / 24)} ${t("days_ago")}`;
  };

  getWrStatusBadgeClass = (status) => {
    switch ((status || "").toLowerCase()) {
      case "pending": return "bg-warning-light text-warning";
      case "approved": return "bg-success-light text-success";
      case "rejected": return "bg-danger-light text-danger";
      case "success": return "bg-success-light text-success";
      default: return "bg-light text-secondary";
    }
  };

  getActivityStyle = (status) => {
    switch ((status || "").toLowerCase()) {
      case "completed":
      case "success":
        return { icon: "", color: "success" };
      case "in_progress":
        return { icon: "", color: "warning" };
      case "assigned":
        return { icon: "", color: "primary" };
      default:
        return { icon: "", color: "secondary" };
    }
  };

  buildConicGradient = (data) => {
    const total = data.reduce((s, d) => s + (d.count || 0), 0);
    if (!total) return "#e9ecef";
    let acc = 0;
    const stops = data.map((d) => {
      const color = WO_STATUS_COLORS[d.status] || "#adb5bd";
      const pct = Math.round((d.count / total) * 100);
      const start = acc;
      acc += pct;
      return `${color} ${start}% ${acc}%`;
    });
    return `conic-gradient(${stops.join(", ")})`;
  };

  render() {
    const { loaded, kpi, wo_by_status, recent_work_requisitions, technicians, recent_activities } = this.state;
    const woTotal = wo_by_status.reduce((s, d) => s + (d.count || 0), 0);

    return (
      <div className="w-100 min-vh-100" style={{ backgroundColor: "#F4F7FE" }}>
        <NavbarAdmin />
        <div className="body p-4 mt-3">

          {/* Header */}
          <div className="mb-4">
            <h3 className="fw-bold mb-1">{t("dashboard")}</h3>
            <div className="text-secondary">{t("welcome_back_admin")}</div>
          </div>

          {/* KPI Row */}
          <div className="row g-3 mb-4">
            <div className="col-lg-3 col-md-6">
              <div className="card border-0 rounded-4 shadow-sm p-3 h-100">
                <div className="d-flex justify-content-between align-items-start">
                  <div>
                    <div className="text-secondary text-14 mb-1">{t("total_open_work_orders")}</div>
                    <h2 className="fw-bold mb-2">{kpi.open_wo}</h2>
                    <div className="text-danger text-12">
                      <span className="icon me-1">{""}</span>{kpi.new_today} {t("new_today")}
                    </div>
                  </div>
                  <div className="wpx-40 hpx-40 rounded bg-primary-light text-primary d-flex align-items-center justify-content-center text-20 icon">
                    {""}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-md-6">
              <div className="card border-0 rounded-4 shadow-sm p-3 h-100">
                <div className="d-flex justify-content-between align-items-start">
                  <div>
                    <div className="text-secondary text-14 mb-1">{t("jobs_in_progress")}</div>
                    <h2 className="fw-bold mb-2 text-warning">{kpi.in_progress}</h2>
                    <div className="text-secondary text-12">
                      <span className="icon me-1">{""}</span>{kpi.techs_active} {t("technicians_active")}
                    </div>
                  </div>
                  <div className="wpx-40 hpx-40 rounded bg-warning-light text-warning d-flex align-items-center justify-content-center text-20 icon">
                    {""}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-md-6">
              <div className="card border-0 rounded-4 shadow-sm p-3 h-100">
                <div className="d-flex justify-content-between align-items-start">
                  <div>
                    <div className="text-secondary text-14 mb-1">{t("pending_work_requests")}</div>
                    <h2 className="fw-bold mb-2 text-danger">{kpi.pending_wr}</h2>
                    <div className="text-danger text-12">
                      <span className="icon me-1">{""}</span>{t("needs_attention")}
                    </div>
                  </div>
                  <div className="wpx-40 hpx-40 rounded bg-danger-light text-danger d-flex align-items-center justify-content-center text-20 icon">
                    {""}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-md-6">
              <div className="card border-0 rounded-4 shadow-sm p-3 h-100">
                <div className="d-flex justify-content-between align-items-start">
                  <div>
                    <div className="text-secondary text-14 mb-1">{t("completed_today")}</div>
                    <h2 className="fw-bold mb-2 text-success">{kpi.completed_today}</h2>
                  </div>
                  <div className="wpx-40 hpx-40 rounded bg-success-light text-success d-flex align-items-center justify-content-center text-20 icon">
                    {""}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Main Grid */}
          <div className="row g-3">
            {/* Left Column */}
            <div className="col-lg-8">

              {/* Recent Work Requests */}
              <div className="card border-0 rounded-4 shadow-sm p-4 mb-3">
                <div className="d-flex align-items-center mb-3">
                  <h5 className="fw-bold mb-0">
                    <span className="icon text-primary me-2">{""}</span>{t("pending_work_requests")}
                  </h5>
                </div>

                {recent_work_requisitions.length === 0 ? (
                  <div className="text-center text-secondary text-14 py-3">
                    {loaded ? t("no_data") : ""}
                  </div>
                ) : (
                  <div className="list-group list-group-flush">
                    {recent_work_requisitions.map((wr, i) => (
                      <div key={wr.uid || i} className="list-group-item px-0 py-3 border-bottom border-light">
                        <div className="d-flex justify-content-between align-items-start">
                          <div className="flex-grow-1 me-3">
                            <div className="d-flex align-items-center mb-1 flex-wrap gap-1">
                              <span className={`badge text-10 px-2 py-1 ${this.getWrStatusBadgeClass(wr.status)}`}>
                                {t(wr.status) !== wr.status ? t(wr.status) : wr.status}
                              </span>
                              <span className="text-secondary text-12">{wr.wr_number}</span>
                            </div>
                            <div className="text-14 text-dark mb-1">
                              {wr.customer_name !== "-" ? wr.customer_name : wr.problem_description}
                            </div>
                            <div className="text-secondary text-12 d-flex align-items-center gap-2">
                              {wr.priority_name !== "-" && (
                                <span>
                                  <span className="icon me-1 text-10">{""}</span>{wr.priority_name}
                                </span>
                              )}
                              {wr.channel && (
                                <span>
                                  <span className="icon me-1 text-10">{""}</span>{wr.channel}
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="text-12 text-secondary text-nowrap">
                            <span className="icon me-1 text-10">{""}</span>
                            {this.timeAgo(wr.created_at)}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              {/* WO by Status + Technician Locations */}
              <div className="row g-3 mb-3">
                <div className="col-md-6">
                  <div className="card border-0 rounded-4 shadow-sm p-4 h-100">
                    <h6 className="fw-bold mb-3">
                      <span className="icon text-primary me-2">{""}</span>{t("work_orders_by_status")}
                    </h6>
                    {woTotal === 0 ? (
                      <div className="d-flex align-items-center justify-content-center py-4 text-secondary text-14">
                        {loaded ? t("no_data") : ""}
                      </div>
                    ) : (
                      <div className="d-flex align-items-center justify-content-center flex-column flex-md-row gap-4 py-3">
                        <div
                          className="rounded-circle position-relative flex-shrink-0"
                          style={{ width: "140px", height: "140px", background: this.buildConicGradient(wo_by_status) }}
                        >
                          <div className="position-absolute top-50 start-50 translate-middle bg-white rounded-circle d-flex flex-column align-items-center justify-content-center" style={{ width: "90px", height: "90px" }}>
                            <h3 className="fw-bold mb-0 text-20">{woTotal}</h3>
                            <div className="text-10 text-secondary">{t("total")}</div>
                          </div>
                        </div>
                        <div>
                          {wo_by_status.map((d, i) => (
                            <div key={i} className="d-flex align-items-center mb-2 text-14">
                              <div className="wpx-10 hpx-10 rounded-circle me-2 flex-shrink-0" style={{ backgroundColor: WO_STATUS_COLORS[d.status] || "#adb5bd" }}></div>
                              {t(d.status) !== d.status ? t(d.status) : d.status} ({d.count})
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="card border-0 rounded-4 shadow-sm p-4 h-100">
                    <h6 className="fw-bold mb-3">
                      <span className="icon text-primary me-2">{""}</span>{t("technician_locations")}
                    </h6>
                    <div className="w-100 rounded-3 bg-light d-flex align-items-center justify-content-center" style={{ height: "180px" }}>
                      <div className="text-center text-secondary text-12">
                        <span className="icon d-block text-30 mb-2">{""}</span>
                        {t("map_view_bangkok_area")}
                      </div>
                    </div>
                    <div className="d-flex justify-content-center gap-3 mt-3 text-12">
                      <div className="d-flex align-items-center"><div className="wpx-8 hpx-8 rounded-circle bg-success me-1"></div>{t("on_site")}</div>
                      <div className="d-flex align-items-center"><div className="wpx-8 hpx-8 rounded-circle bg-warning me-1"></div>{t("en_route")}</div>
                      <div className="d-flex align-items-center"><div className="wpx-8 hpx-8 rounded-circle bg-primary me-1"></div>{t("available")}</div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Recent Activity */}
              <div className="card border-0 rounded-4 shadow-sm p-4 mb-3">
                <div className="d-flex align-items-center mb-4">
                  <h6 className="fw-bold mb-0">
                    <span className="icon text-primary me-2">{""}</span>{t("recent_activity")}
                  </h6>
                </div>

                {recent_activities.length === 0 ? (
                  <div className="text-center text-secondary text-14 py-3">
                    {loaded ? t("no_data") : ""}
                  </div>
                ) : (
                  <div className="position-relative">
                    {recent_activities.map((act, i) => {
                      const style = this.getActivityStyle(act.status);
                      return (
                        <div key={i} className="d-flex mb-4 position-relative">
                          {i !== recent_activities.length - 1 && (
                            <div className="position-absolute bg-light" style={{ width: "2px", height: "100%", left: "19px", top: "30px", zIndex: 0 }}></div>
                          )}
                          <div className={`wpx-40 hpx-40 rounded-circle bg-${style.color}-light text-${style.color} d-flex align-items-center justify-content-center icon text-16 z-1 flex-shrink-0 me-3`}>
                            {style.icon}
                          </div>
                          <div className="w-100 d-flex justify-content-between pt-1">
                            <div>
                              <div className="text-14 text-dark">
                                {act.wo_number} {act.title !== "-" ? `- ${act.title}` : ""}
                              </div>
                              {act.customer_name && (
                                <div className="text-12 text-secondary">{act.customer_name}</div>
                              )}
                            </div>
                            <div className="text-12 text-secondary text-nowrap ms-2">
                              {this.timeAgo(act.updated_at || act.created_at)}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>

            </div>

            {/* Right Column */}
            <div className="col-lg-4">

              {/* Technician Status */}
              <div className="card border-0 rounded-4 shadow-sm p-4">
                <h6 className="fw-bold mb-4">
                  <span className="icon text-primary me-2">{""}</span>{t("technician_status")}
                </h6>

                {technicians.length === 0 ? (
                  <div className="text-center text-secondary text-14 py-4">
                    {loaded ? t("no_data") : ""}
                  </div>
                ) : (
                  <div className="d-flex flex-column gap-3">
                    {technicians.map((tech, i) => (
                      <div key={tech.uid || i} className="d-flex align-items-center">
                        <div className={`wpx-40 hpx-40 rounded-circle text-white d-flex align-items-center justify-content-center fw-bold me-3 ${AVATAR_BG[i % AVATAR_BG.length]}`}>
                          {tech.initials}
                        </div>
                        <div>
                          <div className="fw-bold text-dark text-14">{tech.name}</div>
                          <span className="badge bg-success-light text-success fw-normal text-10">
                            {t("available")}
                          </span>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>

            </div>
          </div>

        </div>
      </div>
    );
  }
}
